module.exports = __webpack_public_path__ + "img/content1.a2ef1708.png";